import React, { lazy } from 'react'
import { Route, Switch, useRouteMatch } from '@fs/zion-router'

const LandingPage = lazy(() => import('./LandingPage/LandingPage'))

export default function Router() {
  const { path } = useRouteMatch()

  return (
    <Switch>
      <Route component={LandingPage} exact path={`${path}/`} />
    </Switch>
  )
}
